import { WitaConnector } from '@/services/repository/connector'
import { FormDataHandler } from '@/utils/helpers/FormDataHandler'
import { querySerializer } from '@/utils/helpers/URLs'

import {
  CreateChamadoEvidenciaParams,
  CreateChamadoEvidenciaResponse,
  DeleteChamadoEvidenciaParams,
  DeleteChamadoEvidenciaResponse,
  SearchChamadoEvidenciasParams,
  SearchChamadoEvidenciasResponse,
} from '../domain/chamado-evidencia'

const ROOT_URL = '/entity/call-evidence-images'

export const ChamadoEvidenciaService = {
  search: async (params: SearchChamadoEvidenciasParams) => {
    const url = ROOT_URL + `?${querySerializer(params)}`
    return await WitaConnector.get<SearchChamadoEvidenciasResponse>(url)
  },

  create: async (params: CreateChamadoEvidenciaParams) => {
    const formData = FormDataHandler(params)
    const url = ROOT_URL
    return await WitaConnector.post<CreateChamadoEvidenciaResponse>(
      url,
      formData,
    )
  },

  delete: async ({ id }: DeleteChamadoEvidenciaParams) => {
    const url = ROOT_URL + `/${id}`
    return await WitaConnector.delete<DeleteChamadoEvidenciaResponse>(url)
  },
}
